import React from 'react';
import Salas from '../../components/salas/Salas';
import JuegoOnline from '../../components/juegoonline/JuegoOnline';
import styled from 'styled-components';

const FullHeightDiv = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;

  & > * {
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Section2 = () => {
  return (
    <FullHeightDiv>
      <Salas />
      {/* <JuegoOnline /> */}
    </FullHeightDiv>
  );
};

export default Section2;
